import React from 'react';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useGetMenuItemQuery } from 'generated/graphql';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';

interface MenuItemInfoDialogProps {
	open: boolean;
	onClose: () => void;
	menuItemID: string | null;
	outletID: string;
}

export const MenuItemInfoDialog: React.FC<MenuItemInfoDialogProps> = ({
	open,
	onClose,
	menuItemID,
	outletID,
}) => {
	const { data, loading } = useGetMenuItemQuery({
		variables: {
			ID: menuItemID || '',
			outletID: outletID,
		},
		skip: !menuItemID || !outletID || !open,
		fetchPolicy: 'network-only',
	});

	const menuItem = data?.getMenuItem?.[0];

	return (
		<CommonDialog
			fullWidth
			maxWidth="sm"
			open={open}
			onClose={onClose}
			sections={{
				header: {
					dynamic: (
						<div className="dialog-dynamic-content">
							<div className="title">Menu Item Information</div>
						</div>
					),
				},
				body: () => (
					<div style={{ minHeight: '200px' }}>
						{loading ? (
							<Loading />
						) : !menuItem ? (
							<EmptyList
								title="Menu item not found"
								subtitle="The requested menu item information could not be loaded"
							/>
						) : (
							<div>
								<div className="content-wrap">
									<div className="desc"> Name</div>
									<div className="xxTitle">{menuItem.name || '-'}</div>
								</div>

								<div className="content-wrap">
									<div className="desc">Major & Family</div>
									<div className="xxTitle">
										{(menuItem as any).major?.name && (menuItem as any).family?.name
											? `${(menuItem as any).major.name} / ${(menuItem as any).family.name}`
											: (menuItem as any).major?.name || (menuItem as any).family?.name || '-'}
									</div>
								</div>

								<div className="content-wrap">
									<div className="desc">Stock UOM</div>
									<div className="xxTitle">{menuItem.stockUom?.name || '-'}</div>
								</div>

								<div className="content-wrap">
									<div className="desc">Min Qty</div>
									<div className="xxTitle">
										{(menuItem as any).minQty !== null && (menuItem as any).minQty !== undefined
											? parseFloat(String((menuItem as any).minQty)).toFixed(4)
											: '-'}
									</div>
								</div>

								<div className="content-wrap">
									<div className="desc">Barcode</div>
									<div className="xxTitle">{menuItem.barCode || '-'}</div>
								</div>
							</div>
						)}
					</div>
				),
				footer: {
					actions: [
						{
							displayText: 'Close',
							props: {
								onClick: onClose,
								variant: 'contained',
								color: 'primary',
							},
						},
					],
				},
			}}
		/>
	);
};

